import once from 'lodash/once';
import { createContext, useContext } from 'react';
export const createAppModalContext = once(() => createContext(undefined));
/**
 * A hook to access the state of a given modal.
 *
 * @example
 *   const { isOpen, modal, hide } = useAppModal('my-modal');
 */
export const useAppModal = (_type) => useContext(createAppModalContext());
